module.exports = __webpack_public_path__ + "img/goal-17.dd7aa14a.png";